<div class="login-page">

  <header class="login-header">
    <div class="brand">
      <img src="{{ BASE_IMG_URL }}assets/logo/rdo-logo.png" alt="Rede de Obras" class="brand-logo" />
    </div>
  </header>

  <main class="login-main">
    <div class="login-card">

      <!-- Formulário -->
      <ng-container *ngIf="!submitted">

        <h1 class="login-title">Redefinir senha</h1>
        <p class="login-subtitle">Digite sua nova senha abaixo.</p>

        <div class="form-error" *ngIf="errorMessage" role="alert">
          {{ errorMessage }}
        </div>

        <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>

          <div class="field" [class.field--error]="passwordControl?.invalid && passwordControl?.touched">
            <label class="field__label" for="password">Nova senha</label>
            <div class="field__password">
              <input
                id="password"
                [type]="showPassword ? 'text' : 'password'"
                formControlName="password"
                placeholder="Mínimo 6 caracteres"
                autocomplete="new-password"
              />
              <button type="button" class="field__toggle" (click)="togglePassword()"
                [attr.aria-label]="showPassword ? 'Ocultar senha' : 'Mostrar senha'">
                <svg *ngIf="!showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
                </svg>
                <svg *ngIf="showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19M1 1l22 22"/>
                </svg>
              </button>
            </div>
            <span class="field__error" *ngIf="passwordControl?.invalid && passwordControl?.touched">
              <span *ngIf="passwordControl?.errors?.['required']">Informe a nova senha.</span>
              <span *ngIf="passwordControl?.errors?.['minlength']">A senha deve ter no mínimo 6 caracteres.</span>
            </span>
          </div>

          <div class="field" [class.field--error]="confirmPasswordControl?.touched && form.errors?.['passwordsMismatch']">
            <label class="field__label" for="confirmPassword">Confirmar nova senha</label>
            <div class="field__password">
              <input
                id="confirmPassword"
                [type]="showConfirmPassword ? 'text' : 'password'"
                formControlName="confirmPassword"
                placeholder="Repita a senha"
                autocomplete="new-password"
              />
              <button type="button" class="field__toggle" (click)="toggleConfirmPassword()"
                [attr.aria-label]="showConfirmPassword ? 'Ocultar senha' : 'Mostrar senha'">
                <svg *ngIf="!showConfirmPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
                </svg>
                <svg *ngIf="showConfirmPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19M1 1l22 22"/>
                </svg>
              </button>
            </div>
            <span class="field__error" *ngIf="confirmPasswordControl?.touched && form.errors?.['passwordsMismatch']">
              As senhas não coincidem.
            </span>
          </div>

          <button type="submit" class="btn-entrar" [disabled]="isLoading || !token">
            <span *ngIf="!isLoading">Redefinir senha</span>
            <span *ngIf="isLoading" class="loading-spinner" aria-label="Carregando"></span>
          </button>

        </form>

      </ng-container>

      <!-- Sucesso -->
      <ng-container *ngIf="submitted">
        <div class="success-box">
          <div class="success-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
              <polyline points="22 4 12 14.01 9 11.01"/>
            </svg>
          </div>
          <h1 class="login-title">Senha redefinida!</h1>
          <p class="login-subtitle">Sua senha foi alterada com sucesso. Agora você pode entrar com a nova senha.</p>
          <button type="button" class="btn-entrar" (click)="goToLogin()">Ir para o login</button>
        </div>
      </ng-container>

    </div>
  </main>

  <footer class="login-footer">
    <span>Uma plataforma</span>
    <img src="{{ BASE_IMG_URL }}assets/logo/construmarket.png" alt="Construmarket" height="22" class="footer-logo" />
    <img src="{{ BASE_IMG_URL }}assets/logo/convisao.webp" alt="ConVisão" width="auto" height="22" class="footer-logo" />
  </footer>

</div>